import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=17d7efa4&scoped=true"
import script from "./reset-password.vue?vue&type=script&lang=js"
export * from "./reset-password.vue?vue&type=script&lang=js"
import style0 from "./reset-password.scss?vue&type=style&index=0&id=17d7efa4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d7efa4",
  null
  
)

export default component.exports